/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ReferralRecipientConfig } from './ReferralRecipientConfig';
import {
    ReferralRecipientConfigFromJSON,
    ReferralRecipientConfigFromJSONTyped,
    ReferralRecipientConfigToJSON,
} from './ReferralRecipientConfig';

/**
 * 
 * @export
 * @interface FindAllReferralRecipientConfigs200Response
 */
export interface FindAllReferralRecipientConfigs200Response {
    /**
     * 
     * @type {Array<ReferralRecipientConfig>}
     * @memberof FindAllReferralRecipientConfigs200Response
     */
    data?: Array<ReferralRecipientConfig>;
}

/**
 * Check if a given object implements the FindAllReferralRecipientConfigs200Response interface.
 */
export function instanceOfFindAllReferralRecipientConfigs200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllReferralRecipientConfigs200ResponseFromJSON(json: any): FindAllReferralRecipientConfigs200Response {
    return FindAllReferralRecipientConfigs200ResponseFromJSONTyped(json, false);
}

export function FindAllReferralRecipientConfigs200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllReferralRecipientConfigs200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(ReferralRecipientConfigFromJSON)),
    };
}

export function FindAllReferralRecipientConfigs200ResponseToJSON(value?: FindAllReferralRecipientConfigs200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(ReferralRecipientConfigToJSON)),
    };
}

